import { getQueryParams } from '../routing/getQueryParams';
import { QUERY_PARAM } from './QUERY_PARAM';
export const isPostVerification = () => {
  const queryParams = getQueryParams();
  return Boolean(queryParams[QUERY_PARAM.TOKEN]);
};
export const isPreVerification = () => {
  return !isPostVerification();
};